module.exports = __webpack_public_path__ + "media/application/images/2023/Headline MD-7981ca3bca93198434fb8c52932c125a.png";